import { MapPin } from "lucide-react";
import { Link } from "react-router-dom";

// Map of towns with dedicated pages
const townLinks: Record<string, string> = {
  // Berkshire
  "Reading": "/reading-garage-door-repairs",
  "Wokingham": "/wokingham-garage-door-repairs",
  "Newbury": "/newbury-garage-door-repairs",
  "Bracknell": "/bracknell-garage-door-repairs",
  "Maidenhead": "/maidenhead-garage-door-repairs",
  "Slough": "/slough-garage-door-repairs",
  "Windsor": "/windsor-garage-door-repairs",
  "Ascot": "/ascot-garage-door-repairs",
  "Sandhurst": "/sandhurst-garage-door-repairs",
  "Crowthorne": "/crowthorne-garage-door-repairs",
  "Burnham": "/burnham-garage-door-repairs",
  "Calcot": "/calcot-garage-door-repairs",
  "Caversham": "/caversham-garage-door-repairs",
  "Cookham": "/cookham-garage-door-repairs",
  "Datchet": "/datchet-garage-door-repairs",
  "Earley": "/earley-garage-door-repairs",
  "Finchampstead": "/finchampstead-garage-door-repairs",
  "Hungerford": "/hungerford-garage-door-repairs",
  "Iver": "/iver-garage-door-repairs",
  "Langley": "/langley-garage-door-repairs",
  "Marlow": "/marlow-garage-door-repairs",
  "Pangbourne": "/pangbourne-garage-door-repairs",
  "Sunningdale": "/sunningdale-garage-door-repairs",
  "Sunninghill": "/sunninghill-garage-door-repairs",
  "Thatcham": "/thatcham-garage-door-repairs",
  "Theale": "/theale-garage-door-repairs",
  "Tilehurst": "/tilehurst-garage-door-repairs",
  "Twyford": "/twyford-garage-door-repairs",
  "Warfield": "/warfield-garage-door-repairs",
  "Woodley": "/woodley-garage-door-repairs",
  // Hampshire
  "Southampton": "/southampton-garage-door-repairs",
  "Portsmouth": "/portsmouth-garage-door-repairs",
  "Winchester": "/winchester-garage-door-repairs",
  "Basingstoke": "/basingstoke-garage-door-repairs",
  "Aldershot": "/aldershot-garage-door-repairs",
  "Farnborough": "/farnborough-garage-door-repairs",
  "Fleet": "/fleet-garage-door-repairs",
  "Alton": "/alton-garage-door-repairs",
  "Andover": "/andover-garage-door-repairs",
  "Bishops Waltham": "/bishops-waltham-garage-door-repairs",
  "Chandlers Ford": "/chandlers-ford-garage-door-repairs",
  "Eastleigh": "/eastleigh-garage-door-repairs",
  "Fareham": "/fareham-garage-door-repairs",
  "Fordingbridge": "/fordingbridge-garage-door-repairs",
  "Gosport": "/gosport-garage-door-repairs",
  "Hartley Wintney": "/hartley-wintney-garage-door-repairs",
  "Havant": "/havant-garage-door-repairs",
  "Hedge End": "/hedge-end-garage-door-repairs",
  "Hook": "/hook-garage-door-repairs",
  "Lymington": "/lymington-garage-door-repairs",
  "New Milton": "/new-milton-garage-door-repairs",
  "Odiham": "/odiham-garage-door-repairs",
  "Petersfield": "/petersfield-garage-door-repairs",
  "Ringwood": "/ringwood-garage-door-repairs",
  "Romsey": "/romsey-garage-door-repairs",
  "Waterlooville": "/waterlooville-garage-door-repairs",
  "Whitchurch": "/whitchurch-garage-door-repairs",
  "Yateley": "/yateley-garage-door-repairs",
  // Surrey
  "Guildford": "/guildford-garage-door-repairs",
  "Woking": "/woking-garage-door-repairs",
  "Farnham": "/farnham-garage-door-repairs",
  "Redhill": "/redhill-garage-door-repairs",
  "Camberley": "/camberley-garage-door-repairs",
  "Cobham": "/cobham-garage-door-repairs",
  "Dorking": "/dorking-garage-door-repairs",
  "Godalming": "/godalming-garage-door-repairs",
  "Epsom": "/epsom-garage-door-repairs",
  "Addlestone": "/addlestone-garage-door-repairs",
  "Ash": "/ash-garage-door-repairs",
  "Ashtead": "/ashtead-garage-door-repairs",
  "Bramley": "/bramley-garage-door-repairs",
  "Caterham": "/caterham-garage-door-repairs",
  "Chertsey": "/chertsey-garage-door-repairs",
  "Cranleigh": "/cranleigh-garage-door-repairs",
  "Egham": "/egham-garage-door-repairs",
  "Esher": "/esher-garage-door-repairs",
  "Haslemere": "/haslemere-garage-door-repairs",
  "Horley": "/horley-garage-door-repairs",
  "Leatherhead": "/leatherhead-garage-door-repairs",
  "Oxted": "/oxted-garage-door-repairs",
  "Reigate": "/reigate-garage-door-repairs",
  "Shalford": "/shalford-garage-door-repairs",
  "Staines": "/staines-garage-door-repairs",
  "Tongham": "/tongham-garage-door-repairs",
  "Virginia Water": "/virginia-water-garage-door-repairs",
  "Walton-on-Thames": "/walton-on-thames-garage-door-repairs",
  "Weybridge": "/weybridge-garage-door-repairs",
};

const AreasSection = () => {
  const areas = [
    {
      name: "Berkshire",
      link: "/berkshire",
      towns: ["Reading", "Wokingham", "Newbury", "Bracknell", "Maidenhead", "Slough", "Windsor", "Ascot", "Sandhurst", "Crowthorne"],
    },
    {
      name: "Hampshire",
      link: "/hampshire",
      towns: ["Southampton", "Portsmouth", "Winchester", "Basingstoke", "Aldershot", "Farnborough", "Fleet", "Alton"],
    },
    {
      name: "Surrey",
      link: "/surrey",
      towns: ["Guildford", "Woking", "Farnham", "Redhill", "Camberley", "Cobham", "Dorking", "Godalming"],
    },
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-accent/10 px-4 py-2 rounded-full mb-4">
            <MapPin className="w-5 h-5 text-accent" />
            <span className="text-accent font-semibold">Service Coverage</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">Areas We Cover</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {areas.map((area) => (
            <div key={area.name} className="text-center md:text-left">
              <Link 
                to={area.link} 
                className="text-2xl font-bold text-foreground mb-6 pb-2 border-b-2 border-accent inline-block hover:text-accent transition-colors"
              >
                {area.name}
              </Link>
              <ul className="grid grid-cols-2 md:grid-cols-1 gap-2 mt-4">
                {area.towns.map((town) => {
                  const link = townLinks[town];
                  return link ? (
                    <li key={town}>
                      <Link 
                        to={link} 
                        className="text-muted-foreground hover:text-accent transition-colors"
                      >
                        {town}
                      </Link>
                    </li>
                  ) : (
                    <li key={town} className="text-muted-foreground">
                      {town}
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AreasSection;
